class NewsletterModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.newsletterCTA = this.querySelector('[data-cta]');
    this.modal = this.querySelector('[data-modal]');
    this.close = this.querySelector('[data-close]');
    this.bindEventListeners();
    this.onSubmissionSuccess();
  }

  bindEventListeners() {
    // Show the modal when the CTA is clicked
    this.newsletterCTA.addEventListener('click', () => {
      this.showModal();
    });

    // Close the modal when the close button is clicked
    this.close.addEventListener('click', () => {
      this.closeModal();
    });

    // Close the modal when a click occurs outside of it
    this.modal.addEventListener('click', event =>
      this.closeModalOnOutsideClick(event)
    );
  }

  /**
   * Show the modal and disable page scroll
   * @returns {void}
   */
  showModal() {
    this.modal.showModal();
  }

  /**
   * Close the modal and enable page scroll
   * @returns {void}
   */
  closeModal() {
    this.modal.close();
  }

  /**
   * Close the modal if a click occurs outside of it
   * @param {event} event
   * @returns {void}
   */
  closeModalOnOutsideClick(event) {
    const modalDimensions = this.modal.getBoundingClientRect();
    if (
      event.clientX < modalDimensions.left ||
      event.clientX > modalDimensions.right ||
      event.clientY < modalDimensions.top ||
      event.clientY > modalDimensions.bottom
    ) {
      this.closeModal();
    }
  }

  /**
   * Open the modal if the customer was successfully added to the newsletter
   * @returns {void}
   */
  onSubmissionSuccess() {
    if (globalThis.location.search.includes('customer_posted=true')) {
      // Open the modal to see success message
      this.showModal();

      // Close the modal after 5 seconds
      setTimeout(() => {
        this.closeModal();
      }, 5000);
    }
  }
}

customElements.get('newsletter-modal') ||
  customElements.define('newsletter-modal', NewsletterModal);
